/*
 * NextGenn engine · what people said (sections/ngs-reviews.liquid).
 *
 * The whole list is in the HTML and readable with no script at all. This adds
 * the things a reader actually wants: somebody like me, and the rest.
 *
 * "Like me" is two questions, not one — the skin and the age — so the chips are
 * two groups that narrow together, and a chip only ever unsets the chips in its
 * own group. Both are drawn by the section from the reviews themselves, so a
 * group that would find nobody is never on the page to begin with.
 *
 * The chips are drawn hidden and revealed here, so a visitor whose script
 * never arrives is never shown a filter that cannot filter.
 */
if (!customElements.get('ngs-reviews')) {
  customElements.define(
    'ngs-reviews',
    class NgsReviews extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('.ngs-reviews__item'));
        if (!this.items.length) return;

        this.filters = this.querySelector('[data-ngs-filters]');
        this.sortWrap = this.querySelector('[data-ngs-sort-wrap]');
        this.sorter = this.querySelector('[data-ngs-sort]');
        this.list = this.querySelector('.ngs-reviews__list');
        this.more = this.querySelector('[data-ngs-more]');
        this.none = this.querySelector('[data-ngs-none]');
        this.shown = Number(this.dataset.shown) || 4;
        this.skin = '';
        this.age = '';
        this.all = false;

        if (this.filters) this.filters.hidden = false;
        if (this.more) this.more.hidden = false;
        /* Drawn hidden and revealed here: a visitor whose script never arrives
           is never shown a control that cannot do anything. */
        if (this.sortWrap && this.items.length > 2) this.sortWrap.hidden = false;
        if (this.sorter) {
          this.onSort = this.onSort.bind(this);
          this.sorter.addEventListener('change', this.onSort);
        }

        this.onClick = this.onClick.bind(this);
        this.addEventListener('click', this.onClick);
        this.draw();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        if (this.sorter && this.onSort) this.sorter.removeEventListener('change', this.onSort);
      }

      /* The DOM order is the truth: the list is reordered rather than hidden
         and redrawn, so a filter and an order can be on at the same time. */
      onSort() {
        var how = this.sorter.value;
        var rank = function (item) {
          if (how === 'high') return -Number(item.dataset.rating || 0);
          if (how === 'low') return Number(item.dataset.rating || 0);
          if (how === 'long') return -Number(item.dataset.weeks || 0);
          return Number(item.dataset.order || 0);
        };
        var sorted = this.items.slice().sort(function (a, b) {
          var d = rank(a) - rank(b);
          /* A stable tie-break, so two four-stars never swap places between
             one sort and the next. */
          return d !== 0 ? d : Number(a.dataset.order || 0) - Number(b.dataset.order || 0);
        });
        var list = this.list;
        sorted.forEach(function (item) {
          list.appendChild(item);
        });
        this.items = sorted;
        /* A new order means a new first four. */
        this.all = false;
        this.draw();
      }

      onClick(event) {
        var chip = event.target.closest('.ngs-reviews__chip');
        if (chip) {
          var axis = chip.dataset.axis === 'age' ? 'age' : 'skin';
          this[axis] = chip.dataset[axis] || '';
          /* A filter with everything folded away under a button would hide the
             very reviews somebody just asked to see. */
          this.all = true;
          /* Only this group lets go: choosing an age must not quietly undo the
             skin somebody picked a second ago. */
          var group = chip.closest('.ngs-reviews__group') || this;
          Array.prototype.forEach.call(group.querySelectorAll('.ngs-reviews__chip'), function (each) {
            each.setAttribute('aria-pressed', String(each === chip));
          });
          this.draw();
          return;
        }
        if (event.target.closest('[data-ngs-more]')) {
          this.all = true;
          this.draw();
        }
      }

      draw() {
        var skin = this.skin;
        var age = this.age;
        var all = this.all;
        var shown = this.shown;
        var kept = 0;
        this.items.forEach(function (item) {
          var matches = (!skin || item.dataset.skin === skin) && (!age || item.dataset.age === age);
          if (!matches) {
            item.hidden = true;
            return;
          }
          kept += 1;
          item.hidden = !all && kept > shown;
        });
        if (this.none) this.none.hidden = kept > 0;
        if (this.more) this.more.hidden = all || kept <= shown;
      }
    }
  );
}
